import {
  Component, Input, Output, EventEmitter,
  ChangeDetectionStrategy, ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
import { PropertyPhoto } from '../../shared/models';
import { PropertyComponentTypeahead, FiscalYear } from 'app/internal/shared/models';
import { ModalComponent } from 'app/internal/shared/components';
import { SetBackToPhotos } from 'app/internal/component/component-store';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducers';

@Component({
  selector: 'sp-edit-photo-pane',
  templateUrl: './edit-photo-pane.component.html',
  styleUrls: ['./edit-photo-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})

export class EditPhotoPaneComponent implements OnChanges {

  @Input() photo: PropertyPhoto;
  @Input() propertyId: string;
  @Input() fiscalYear: FiscalYear;

  @Output() closePane: EventEmitter<void> = new EventEmitter<void>();
  @Output() previewPhoto: EventEmitter<void> = new EventEmitter<void>();
  @Output() updatePhoto: EventEmitter<PropertyPhoto> = new EventEmitter<PropertyPhoto>();
  @Output() deletePhoto: EventEmitter<void> = new EventEmitter<void>();
  @Output() downloadPhoto: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('deletePhotoModal', { static: true }) public deletePhotoModal: ModalComponent;

  displayComponentTypeahead = false;

  selectedComponent: PropertyComponentTypeahead;
  unassignComponent = false;
  //setAsPrimaryPhoto = true;
  includeInPhotosReportOptions = [{ id: 'true', name: 'Yes' }, { id: 'false', name: 'No' }];

  constructor(private store: Store<AppState>) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photo']) {
      this.hideAndClearComponentTypeahead();
    }
  }

  onComponentEdit() {
    this.displayComponentTypeahead = true;
  }

  saveAssignedComponent() {
    if (this.unassignComponent) {
      this.photo.propertyComponents = []; // for display update.
    } else {

      this.photo.propertyComponents = []; //Always reset the list. 
      this.photo.propertyComponents.push({
        propertyComponentId: this.selectedComponent.propertyComponentId,
        name: this.selectedComponent.name // for display update.
      });

      //this.photo.isPrimary = this.setAsPrimaryPhoto;  //make the latest photo assigned the primary photo for the component.
    }

    this.updatePhoto.emit(this.photo);
    this.hideAndClearComponentTypeahead();
  }

  hideAndClearComponentTypeahead() {
    this.displayComponentTypeahead = false;
    this.selectedComponent = null;
    this.unassignComponent = false;
    //this.setAsPrimaryPhoto = true;
  }

  saveDescription($event: any, photo: PropertyPhoto) {
    photo.description = $event;
    this.updatePhoto.emit(photo);
  }

  saveIncludeInPhotosReport($event: any, photo: PropertyPhoto) {
    photo.includeInPhotosReport = $event;
    this.updatePhoto.emit(photo);
  }

  onDownloadPhoto() {
    this.downloadPhoto.next();
  }

  onDeletePhoto() {
    this.deletePhotoModal.show();
  }

  onDeletePhotoConfirm() {
    this.deletePhoto.next();
  }

  showPhotoViewer() {
    this.previewPhoto.next();
  }

  setSelectedComponent(component: PropertyComponentTypeahead) {
    this.selectedComponent = component;
  }

  toggleUnassign() {
    this.unassignComponent = !this.unassignComponent;
  }

  // toggleSetAsPrimaryPhoto() {
  //   this.setAsPrimaryPhoto = !this.setAsPrimaryPhoto;
  // }

  setComponentDetailBackToPhotos() {
    this.store.dispatch(new SetBackToPhotos(true));
  }

  onCloseEditPane() {
    this.closePane.next();
  }

}
